// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { orderSummaryCardStyles } from "@ces/Overrides/Components/OrderSummaryCard";
import { fontConfig } from "@ces/XDL/PreStyle/typography";
import { color } from "@ces/XDL/Utilities";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

orderSummaryCardStyles.actionsCells = {
    css: css`
        min-width: 105px;
        max-width: 160px;
        text-align: center;
    `,
};

orderSummaryCardStyles.reorderButton = {
    variant: "primary",
    sizeVariant: "small",
    css: css`
        width: 100%;
        color: ${color("text.main")};
    `,
};

orderSummaryCardStyles.reorderButtonSpinner = {
    size: 16,
    color: "primary",
};

orderSummaryCardStyles.dataCells = {
    css: css`
        ${TypographyStyle} {
            font-weight: ${fontConfig.weight.regular};
            &:hover {
                color: ${color("text.main")};
            }
        }
    `,
};

orderSummaryCardStyles.shipToCells = {
    css: css`
        text-wrap: wrap;
    `,
};
